import { TableCell } from '@material-ui/core';
import React, { FC, memo } from 'react';
import { useIntl } from 'react-intl';

import globalMessages from 'shared/global/messages';

import useStyles from './styles';

export interface ApplicantTableV2ProgressCellProps {
  completedStages?: number;
  totalStages?: number;
}

export const ApplicantTableV2ProgressCell: FC<
  ApplicantTableV2ProgressCellProps
> = ({ completedStages, totalStages }) => {
  const styles = useStyles();
  const intl = useIntl();

  return (
    <TableCell role="cell" className={styles.td}>
      {completedStages && totalStages && (
        <div
          className={styles.progressBarContainer}
          role="progressbar"
          aria-label={intl.formatMessage(globalMessages.progress)}
          aria-valuemin={0}
          aria-valuenow={completedStages}
          aria-valuemax={totalStages}
        >
          <div
            className={styles.progressBar}
            style={{
              width: `${Math.round((completedStages / totalStages) * 100)}%`,
            }}
          />
        </div>
      )}
    </TableCell>
  );
};

export default memo(ApplicantTableV2ProgressCell);
